import { SVGProps, Ref, forwardRef } from 'react';

export const SmileFaceFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m6.675 2.985a.47.47 0 0 1-.143-.32h-1.4c0 .501.209.944.522 1.278.45.48 1.127.754 1.844.754s1.393-.274 1.843-.754c.314-.334.523-.777.523-1.279h-1.4c0 .098-.039.21-.143.32-.158.169-.45.313-.823.313s-.665-.144-.823-.312m-1.51-5.92c-.461 0-.783.155-.988.4-.202.243-.278.56-.278.867s.076.623.278.866c.205.245.527.4.988.4.462 0 .784-.155.988-.4.202-.243.279-.56.279-.866 0-.307-.077-.624-.279-.866-.204-.246-.526-.4-.988-.4m4.666 0c-.462 0-.784.155-.988.4-.202.243-.279.56-.279.867s.077.623.279.866c.204.245.526.4.988.4s.783-.155.988-.4c.202-.243.278-.56.278-.866 0-.307-.076-.624-.278-.866-.205-.246-.527-.4-.988-.4"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmileFaceFilledSize16Glyph.displayName = 'SmileFaceFilledSize16Glyph';
